<template>
  <section>
    <div class="row mt-2">
      <div class="col">
        <span>Select those locations this user will have access to.</span>
      </div>
    </div>
    <div class="row">
      <div class="col custom-firm-list-wrapper">
        <div class="row">
          <div class="col custom-user-role">
            <span></span>
          </div>
          <div class="col-1 mr-2">
            <span>Primary</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul class="custom-list">
              <li v-for="(firm, idx) of firms" :key="idx">
                <div class="row">
                  <div class="col">
                    <input
                      :id="firm.firm"
                      v-model="firm.checked"
                      type="checkbox"
                      :true-value="true"
                      :false-value="false"
                      class="custom-checkbox me-2"
                      @click="changed(firm)"
                    />
                    <span class="ml-2">{{ firm.firmName }}</span>
                  </div>
                  <!-- <div class="col-4">
                    <select v-model="firm.role" class="form-control" @change="changed(firm)">
                      <option value="" disabled selected>user role for this location</option>
                      <option v-for="role of userRoles" :key="role.value" :value="role.value">
                        {{ role.description }}
                      </option>
                    </select>
                  </div> -->
                  <div class="col-1 text-center">
                    <input
                      :id="`${firm.firm}_${idx}`"
                      v-model="firm.isPrimary"
                      type="checkbox"
                      :true-value="1"
                      :false-value="0"
                      :disabled="!firm.checked"
                      class="custom-checkbox me-2"
                      @click="primary(firm)"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'UserLocations',
  data() {
    return {
      firms: []
    }
  },
  async mounted() {
    await this.init()
  },
  emits: ['changed', 'saved'],
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('users', ['user', 'roles', 'userFirms'])
  },
  methods: {
    ...mapActions('users', ['getUserFirms', 'saveUserFirms', 'setFirm', 'setPrimaryFirm']),
    async init() {
      this.firms = []
      await this.getUserFirms({
        user: this.user.user,
        isAll: true
      })
      this.resetFirms()
    },
    resetFirms() {
      if (this.userFirms) {
        this.firms = JSON.parse(JSON.stringify(this.userFirms))
      }
      console.log('Got User Firms (2)', this.firms)
    },
    changed(firm) {
      console.log('Setting Firm', firm)
      this.setFirm(firm.firm)
      this.resetFirms()
      this.$emit('changed')
    },
    primary(firm) {
      this.setPrimaryFirm(firm.firm)
      this.resetFirms()
      this.$emit('changed')
    },
    async save() {
      let response = {
        valid: false,
        user: this.user.user,
        msg: null
      }
      await this.saveUserFirms()
      await this.init()
      response.valid = true
      this.$emit('saved')
      return response
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-firm-list-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
  height: 380px;
  padding-right: 20px;
}
.custom-list {
  list-style: none;
  li {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.custom-row {
  width: 100%;
  display: inline;
}
.custom-user-role {
  span {
    font-weight: 500;
    margin-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-locations.vue